import React, {useEffect, useEffectEvent, useState} from 'react';
import {Alert} from '@mui/material';
import {useLocalization} from 'localization';
import {useGetBulkUpdatesQuery} from 'services/bulkUpdates/bulkUpdatesApi';
import {Spacer} from 'components';

export const BulkUpdateInProgress = () => {
  const {t} = useLocalization();
  // Checking the last 5 sorted by created is more than enough.
  const {data} = useGetBulkUpdatesQuery({
    page: 0,
    size: 5,
  });

  const [inProgress, setInProgress] = useState<boolean>(false);
  const handleSetInProgress = useEffectEvent(setInProgress);

  useEffect(() => {
    if (data) {
      handleSetInProgress(data.items.some(i => !i.completed));
    }
  }, [data]);

  if (inProgress) {
    return (
      <>
        <Alert severity={'warning'}>
          {t('page.bulkUpdate.inprogress.info')}
        </Alert>
        <Spacer height={2} />
      </>
    );
  }

  return null;
};
